import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewContainerRef} from '@angular/core';
import {o, OdataQuery} from "odata";
import {FilterComponent} from "../filter/filter.component";
import {FilterSettings, FilterOption, FilterUtils} from "../filter";

export type ListOption = {
    Value?: string | number,
    Filter?: string,
    Text: string
};

@Component({
    selector: 'list-filter',
    templateUrl: './list-filter.component.html'
})
export class ListFilterComponent extends FilterComponent {
    
    public Options: FilterOption[] = [
        {
            Name: 'Is',
            FilterClauseFormat: '{{0}} eq {1}'
        },
        {
            Name: 'Is Not',
            FilterClauseFormat: '{{0}} ne {1}'
        }
    ];
    
    public SelectedFilterOption: FilterOption;
    
    public SelectedListOption: ListOption;
    
    constructor() {
        super();
        this.SelectedFilterOption = this.Options[0];
    }
    
    ngOnInit() {
        if (this.FilterSettings) {
            this.SelectedFilterOption = this.FilterSettings.FilterModel.Option;
            this.SelectedListOption = this.FilterSettings.FilterModel.Value;
        }
        else {
            this.SelectedFilterOption = this.Options[0];
        }
    }

    updateFilterSettings() {
        
        let filterClause: string = this.SelectedListOption.Filter;
        
        if (filterClause) {
            if (this.SelectedFilterOption.Name == 'Is Not') {
                filterClause = 'not (' + filterClause + ')';
            }
        } else {
            let value: string;
            
            if (this.SelectedListOption.Value == null) {
                value = 'null';
            }
            else if (typeof this.SelectedListOption.Value == 'string') {
                value = "'" + this.SelectedListOption.Value.replace("'", "''")+ "'"
            }
            else {
                value = this.SelectedListOption.Value.toString();
            }
            
            filterClause = FilterUtils.format(
                this.SelectedFilterOption.FilterClauseFormat,
                '0',
                value);
        }
        
        this.FilterSettingsChange.emit(new FilterSettings(
            filterClause,
            {
                Option: this.SelectedFilterOption,
                Value: this.SelectedListOption
            }
        ));
    }
}
